<page-header
    icon="{{['SIDEMENUES', 'ADMIN', 'USERS'] | monIcons}}"
    header="{{'API Users' | translate}}">
    <page-header-content>
        <div class="text-right">
            <button class="btn btn-border-radius btn-secondary" (click)="openDialog()" type="button" translate>
                Add API user
            </button>
        </div>
    </page-header-content>
</page-header>
<div class="card panel-monsido-card">
    <div class="card-body">
        <table-container
                [collection]="apiUsers"
                (onPageChange)="onPageChange($event)"
                (onPerPageChange)="onPageSizeChange($event)"
                class="table-vertial-align"
                [progress]="promise">
            <table class="table table-hover table-fixed">
                <thead>
                <tr>
                    <th class="col-10 col-lg-8" translate>API URL</th>
                    <th translate>Description</th>
                    <th class="col-10 col-lg-6" translate>Scopes</th>
                    <th class="col-7 col-lg-4">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let apiUser of apiUsers; let i = index">
                    <td>
                        <p class="text-multiline">
                            {{apiPath + '/api'}}
                        </p>
                    </td>
                    <td>
                        <p class="text-multiline">
                            {{apiUser.description}}
                        </p>
                    </td>
                    <td>
                        <span *ngFor="let scope of apiUser.scopes; let j = index" class="px-1 inline-block">
                            {{getScopeTranslation(scope)}}
                        </span>
                    </td>
                    <td class="text-right">
                        <mon-action-menu [monActionMenuItems]="apiUser.dropdown">
                            <span translate>Action</span>
                        </mon-action-menu>
                    </td>
                </tr>
                </tbody>
            </table>

        </table-container>
    </div>
</div>
